import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

export const ChangingPassword = ({ value = "" }) => {
  const _token = localStorage.getItem("_token");
  const { proxy, lang, functions } = useSelector((s) => s);
  const { username } = useParams();
  const [password, setPassword] = useState(value);
  const { replaceString } = functions;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const submit = async (data) => {
    const response = await fetch(
      `${proxy()}/auth/v2/user/${username}/password`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${_token}`,
        },
        body: JSON.stringify({ data }),
      }
    );
    const result = await response.json();
    const { success, message } = result;
    Swal.fire({
      title: success ? lang["success.password"] : lang["faild.password"],
      text: lang[message] || message,
      icon: success ? "success" : "error",
      showConfirmButton: success ? false : true,
      timer: 1500,
    });
    if (success) {
      reset();
    }
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      <div
        style={{
          display: "grid",
          justifyItems: "center",
        }}
      >
        {/* <div className="col-sm-6 mb-2">
          <label>{lang["oldPass"]}</label>
          <input
            className="form-control"
            type="password"
            {...register("oldPassword", { required: true })}
          />
          {errors.oldPassword && (
            <p className="error-message">
              {replaceString(lang["required"], [lang["oldPass"]])}
            </p>
          )}
        </div> */}
        <div className="col-sm-7 mb-2">
          <label>
            {lang["newPass"]}:<span style={{ color: "red" }}>*</span>
          </label>
          <input
            className="form-control"
            type="password"
            {...register("newPass", { required: true })}
          />
          {errors.newPass && (
            <p className="error-message">
              {replaceString(lang["required"], [lang["newPass"]])}
            </p>
          )}
        </div>
        <div className="col-sm-7 mb-2">
          <label>
            {lang["confNewPass"]}:<span style={{ color: "red" }}>*</span>
          </label>
          <input
            className="form-control"
            type="password"
            {...register("confNewPass", { required: true })}
          />
          {errors.confNewPass && (
            <p className="error-message">
              {replaceString(lang["required"], [lang["confNewPass"]])}
            </p>
          )}
        </div>
        <div className="col-sm-7 d-flex justify-content-end">
          <button
            type="submit"
            className="btn btn-success btn-custom"
            // onClick={() => handleChangePassword()}
          >
            {lang["changePass"]}
          </button>
        </div>
      </div>
    </form>
  );
};
